module.exports = __webpack_public_path__ + "img/ArmadilloLogo_NavBar_Desktop.6a147503.svg";